<script>
  import { timeParse, timeFormat } from 'd3-time-format'
  let parseTime = timeParse('%Y-%m-%d')
  let formatTime = timeFormat('%e %B %Y')

  import { formatThousands } from '../functions.js'
  let provs = ['GP', 'WC', 'FS', 'KZN', 'EC', 'LP', 'MP', 'NW', 'NC']
  function cleanProvinces() {
    console.log(provincesData)

    let p = provincesData.filter((d) => d.province !== 'Unknown')
    p.forEach((d) => (d.day_no = +d.day_no))
    // let p2 = p.filter((d) => d.active_cases !== '0')
    let p2 = p
    let newData = []
    provs.forEach((e) => {
      newData[e] = []
      let nd = p2.filter((d) => d.province_id === e && +d.daily_deaths > 0)
      let nd2 = nd.filter((d, i) => i > nd.length - 3)
      newData[e] = [...nd2]
    })
    // console.log(newData)
    console.log(newData)

    return newData
  }

  export let provincesData
  let cleanProvincesData = cleanProvinces()
</script>

<div class="chart-title">Provinces</div>
<div class="updated">
  Updated {formatTime(parseTime(cleanProvincesData['GP'][1].date))}
</div>

<!-- <div class="table">
  {#each provs as p}
    <div class="table-block">
      <div class="table-head">{cleanProvincesData[p][1].province_id}</div>
      <div class="table-title">Total Cases</div>
      <div class="table-number">
        {formatThousands(+cleanProvincesData[p][1].cumulative_cases)}
      </div>
      <div class="table-number small red">
        +{formatThousands(+cleanProvincesData[p][1].daily_cases)}
      </div>
      <div class="table-title top-space">Deaths</div>
      <div class="table-number">
        {formatThousands(+cleanProvincesData[p][1].cumulative_deaths)}
      </div>
      <div class="table-number small red">
        {formatThousands(+cleanProvincesData[p][1].daily_deaths) > 0
          ? `+${formatThousands(+cleanProvincesData[p][1].daily_deaths)}`
          : '0'}
      </div>
    </div>
  {/each}
</div> -->

<div class="table-layout">
  <table class="tg">
    <thead>
      <tr>
        <th class="tg-0lax" rowspan="2">Province</th>
        <th class="tg-0lax" colspan="2">Cases</th>
        <!-- <th class="tg-0lax" colspan="2">Deaths</th> -->

        <th class="tg-0lax" colspan="2">Active Cases</th>
      </tr>
      <tr>
        <th class="th-light">Total</th>
        <th class="th-light">Change</th>
        <!-- <th class="th-light">Total</th>
        <th class="th-light">Change</th> -->
        <th class="th-light">Total</th>
        <th class="th-light">Per 100K</th>
      </tr>
      {#each provs as prov}
        <tr>
          <td class="label">{prov}</td>
          <td class="th-light"
            >{formatThousands(
              +cleanProvincesData[prov][1].cumulative_cases
            )}</td
          >
          <td
            class="th-light {+cleanProvincesData[prov][1].daily_cases > 0
              ? 'red-text '
              : ''}"
            >+{formatThousands(+cleanProvincesData[prov][1].daily_cases)}</td
          >
          <!-- <td class="th-light"
            >{formatThousands(
              +cleanProvincesData[prov][1].cumulative_deaths
            )}</td
          > -->
          <!-- <td
            class="th-light {+cleanProvincesData[prov][1].daily_deaths > 0
              ? 'red-text'
              : ''}"
            >{formatThousands(+cleanProvincesData[prov][1].daily_deaths) > 0
              ? `+${formatThousands(+cleanProvincesData[prov][1].daily_deaths)}`
              : '0'}</td
          > -->
          <td class="th-light"
            >{formatThousands(+cleanProvincesData[prov][1].active_cases)}</td
          >
          <td class="th-light"
            >{formatThousands(
              (
                (+cleanProvincesData[prov][1].active_cases /
                  +cleanProvincesData[prov][1].population) *
                100000
              ).toFixed(0)
            )}</td
          >
        </tr>
      {/each}
    </thead>
  </table>
</div>

<style>
  .red-text {
    color: indianred;
    font-weight: 700;
  }
  .whiteText {
    color: #fff;
  }
  table {
    font-size: 0.9rem;
    margin-top: 20px;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;
    border-collapse: collapse;
  }
  td {
    background: #fff;
    border: solid 1px #eee;
  }
  th {
    background: #eee;
    border: solid 1px rgb(194, 194, 194);
    color: #000;
  }
  .table {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(5, 1fr);
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    font-size: 1rem;
    line-height: 1.2rem;
  }
  .table-head {
    font-weight: 700;
  }
  .table-number {
    font-size: 1rem;
    font-weight: 700;
  }
  .table-block {
    background: #eee;
    padding: 10px;
    border-radius: 5px;
  }
  .table-title {
    text-transform: uppercase;
    font-size: 0.8rem;
    margin-bottom: 0px;
  }
  .small {
    font-size: 0.9rem;
  }
  .red {
    color: indianred;
  }
  .top-space {
    margin-top: 10px;
  }
  .label {
    font-weight: 700;
  }
</style>
